'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RichMedia = require('../RichMedia');

var _RichMedia2 = _interopRequireDefault(_RichMedia);

var _VideoPlayer = require('./VideoPlayer');

var _VideoPlayer2 = _interopRequireDefault(_VideoPlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
// Lib
var VideoMedia = function VideoMedia(_ref) {
    var element = _ref.element,
        width = _ref.width,
        gridSize = _ref.gridSize;
    return _react2.default.createElement(_RichMedia2.default, { element: element, width: width, gridSize: gridSize, ContentComponent: _VideoPlayer2.default });
};

VideoMedia.propTypes = {
    element: _propTypes2.default.object.isRequired,
    width: _propTypes2.default.number,
    gridSize: _propTypes2.default.number
};

exports.default = VideoMedia;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/richMedia/components/video/VideoMedia.js
// module id = 2017
// module chunks = 0